import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import valmiki from "../../assets/valmiki.png";
import { TransitionProps } from '@mui/material/transitions';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import './AIGurujiLoginDialog.scss'
import { LOCALIZATION } from '../../utils/localization';
import { t } from 'i18next';

const Transition = React.forwardRef(function Transition(

  props: TransitionProps & {

    children: React.ReactElement<any, any>;

  },

  ref: React.Ref<unknown>,

) {

  return <Slide direction="up" ref={ref} {...props} />;

});

interface AIGurujiLoginDialogProps {
  openModal: boolean,
  closeModal: (type:string) => void
}

export default function AIGurujiLoginDialog({ openModal, closeModal }: AIGurujiLoginDialogProps) {
  const navigate = useNavigate();
  return (
    <React.Fragment>

      <Dialog
        open={openModal}
        TransitionComponent={Transition}
        keepMounted
        className="aIGurujiLoginDialog"
        onClose={() => {
          closeModal("close")
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className="aiGuruLoginDialogTitle">
          {/* <Typography className="icon">🚀</Typography> */}
          <Box 
            component="img"
            src={valmiki}
            alt="Image"
          />
          <Typography className="mainTitle">{t(LOCALIZATION.Unlock_Free_Chat_with_Valmiki)}</Typography>
        </DialogTitle>

        <DialogContent className="aiGuruLoginDialogContent">
          <DialogContentText className="subText" id="alert-dialog-slide-description">
            {t(LOCALIZATION.To_ensure_the_best_predictions)}
          </DialogContentText>
        </DialogContent>

        <DialogActions className="bottomBtnContent">
          <Button variant="outlined" onClick={() => {
            closeModal("close")
          }}>{t(LOCALIZATION.Cancel)}</Button>
          <Button className="loginBtn" variant="contained" onClick={() => {
            navigate("/login")
            closeModal("login")
          }}>{t(LOCALIZATION.Login)}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

  );

}
